export const additionalPrices = [
  {
    id: 4001,
    name: 'Первые 3 метрики',
    nameEn: 'First 3 metrics',
    statusId: 4,
    groupId: 12,
    additionalGroupId: null,
    subtype: 1,
    min: 1,
    step: 1,
    prices: {
      rub: 0,
      eur: 0,
      usd: 0
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    id: 4002,
    name: 'Подписка UTM для Fortinet FG-100E с&nbsp;технической поддержкой вендора, цена за год',
    statusId: 4,
    groupId: 15,
    additionalGroupId: 5,
    subtype: 2,
    min: 1,
    step: 1,
    prices: {
      rub: 13000000,
      eur: 0,
      usd: 0
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    id: 4003,
    name: 'Аренда межсетевого экрана Fortinet FG-100D-LENC/100E-LENC',
    statusId: 4,
    groupId: 15,
    additionalGroupId: 5,
    subtype: 2,
    min: 1,
    step: 1,
    prices: {
      rub: 1500000,
      eur: 0,
      usd: 0
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  },
  {
    id: 4004,
    name: 'Управление межсетевым экраном Fortinet FG-100E (managed-решение)*',
    statusId: 4,
    groupId: 15,
    additionalGroupId: 5,
    subtype: 2,
    min: 1,
    step: 1,
    prices: {
      rub: 1500000,
      eur: 0,
      usd: 0
    },
    oldPrices: {
      rub: null,
      eur: null,
      usd: null
    }
  }
]